import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Card } from '@ff-os/shared-react/components/card/Card';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectIsOptionalById, updateAssetUrlByIds } from '../_redux';
import styles from './SvgInputRemoveSelection.module.scss';

export const _SvgInputRemoveSelection = ({
    variableIds, active, commit
}: Props) => {
    const { t } = useTranslation();
    return (
        <Card onClick={() => commit(variableIds)} active={active}>
            <Grid align='center' justify='center' fullHeight>
                <p className={styles.label}>{t('commons.none')}</p>
            </Grid>
        </Card>
    );
};

type Props = {
    variableIds: string[];
    active?: boolean;
    commit: (variableId: string[]) => void;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    isOptional: selectIsOptionalById(state, ownProps.variableIds[0])!
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch) => ({
    commit: (variableIds: string[]) => dispatch(updateAssetUrlByIds(variableIds, null))
});

export const SvgInputRemoveSelection = connect(
    mapStateToProps,
    mapDispatchToProps
)(_SvgInputRemoveSelection);